import { Box, Button, CircularProgress, Container, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AuthWrapper from 'src/components/AuthWrapper';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import AiVideo from 'src/components/player/AiVideo';
import main_logo from 'src/assets/images/thinkskill.png';
import ThinkskillVideo from 'src/assets/images/Thinkskill-intro-video.mp4';
import { Link, useNavigate } from 'react-router-dom';
import headerImage from 'src/assets/images/header-image.jpg';
import { isEmpty } from 'lodash';
import { getRegionBySlug } from './CareerHistory/CareerHistorySlice';

const LandingPage = () => {
  const { rg_name } = useParams();
  const navigate = useNavigate();
  const token = Cookies.get('feToken');
  const regions = useSelector((state) => state.careerHistory);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [videoOpen, setVideoOpen] = useState(false);

  useEffect(() => {
    if (rg_name) {
      Cookies.set('url-slug', rg_name);
    }
  }, [rg_name]);
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    dispatch(getRegionBySlug(rg_name));
  }, [rg_name, dispatch]);

  useEffect(() => {
    if (regions?.regions) {
      setData(regions?.regions);
      if (!isEmpty(data)) {
        setLoading(false);
      }
    }
  }, [regions?.regions, data]);

  const buttonColor = data?.button?.bgColor;
  const buttonFontColor = data?.button?.color;
  const logo = data?.logo || main_logo;
  const partnerLogos = data?.partnerLogos || [];
  const primaryColor = data?.primaryColor || '';
  const fontColor = data?.fontColor || '';
  const secondaryColor = data?.secondaryColor || '';
  const bgImage = data?.bgImage || '';
  const thm = useTheme();
  const isXs = useMediaQuery(thm.breakpoints.down('sm'));

  const handleLogout = () => {
    Cookies.remove('feToken');
    navigate(`/region/${rg_name}`);
  };

  useEffect(() => {
    const handleTabPress = (e) => {
      if (e.key === 'Tab') {
        e.preventDefault();

        setVideoOpen((prev) => !prev);
      }
    };

    window.addEventListener('keydown', handleTabPress);

    return () => {
      window.removeEventListener('keydown', handleTabPress);
    };
  }, []);

  if (loading) {
    return (
      <Box minHeight="80vh" display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <AuthWrapper title="Landing-Page">
        <Box>
          <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
            <img
              src={headerImage}
              alt="Region Logo"
              style={{ objectFit: 'contain', borderRadius: 8, background: '#fff' }}
            />
          </Box>
          <Box
            className="page-content-wrapper home"
            sx={{
              width: '100%',
              backgroundImage: `url(${bgImage})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundAttachment: 'fixed',
              py: 4,
            }}
          >
            <Container maxWidth="xl">
              <Box pb={5} display="flex" flexDirection="column" alignItems="center">
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: '2.75rem !important',
                    fontFamily: '"Merriweather", serif',
                    fontWeight: 900,
                    color: fontColor,
                    mt: 2,
                    textAlign: 'center',
                  }}
                >
                  <b>Welcome to ThinkSkills</b>
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    mb: 4,
                    color: fontColor,
                    fontSize: '18px !important',
                    fontWeight: 700,
                    fontFamily: '"Work Sans", sans-serif',
                  }}
                >
                  Your future, your skills, your Worcestershire.
                </Typography>
                <Typography sx={{ mb: 2, color: fontColor }} component="p">
                  Whether you're exploring your next career move or strengthening your workforce,
                  ThinkSkills helps people and businesses discover skills, unlock opportunities, and
                  connect with local training providers for the future of work.
                </Typography>
                <Box
                  sx={{
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    p: 4,
                    mt: 4,
                    mb: 4,
                    maxWidth: '650px',
                    width: '100%',
                    textAlign: 'center',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: '2rem !important',
                      fontWeight: 'bold',
                      mb: 3,
                      color: '#333',
                    }}
                  >
                    Get started!
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          textAlign: 'center',
                          mb: 2,
                          ...(!isXs && {borderRight: '2px solid #ccc',}),
                          ...(isXs && {borderBottom: '2px solid #ccc',}),
                          px: 2,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          height: '100%',
                          pb: 2,
                        }}
                      >
                        <Typography sx={{ mb: 2, color: '#666', fontSize: '10px' }}>
                          New here? No problem! Click the button below to get moving.
                        </Typography>
                        <Button
                          component={Link}
                          to={`/region/${rg_name}/career-history`}
                          variant="contained"
                          sx={{
                            backgroundColor: buttonColor,
                            color: buttonFontColor,
                            borderRadius: '8px',
                            px: 4,
                            py: 1,
                            fontWeight: 'bold',
                            '&:hover': {
                              backgroundColor: buttonColor,
                              opacity: 0.9,
                            },
                          }}
                        >
                          Get Started
                        </Button>
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          textAlign: 'center',
                          mb: 2,
                          px: 2,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          flex: 1,
                          height: '100%',
                          pb: 2,
                        }}
                      >
                        <Typography sx={{ mb: 2, color: '#666', fontSize: '10px' }}>
                          {token
                            ? 'Done for now? Sign out.'
                            : 'Already have an account? Jump back in!'}
                        </Typography>
                        {token ? (
                          <Button
                            onClick={handleLogout}
                            variant="contained"
                            sx={{
                              backgroundColor: buttonColor,
                              color: buttonFontColor,
                              borderRadius: '8px',
                              px: 4,
                              py: 1,
                              fontWeight: 'bold',
                              '&:hover': {
                                backgroundColor: buttonColor,
                                opacity: 0.9,
                              },
                            }}
                          >
                            Logout
                          </Button>
                        ) : (
                          <Button
                            component={Link}
                            to={`/region/${rg_name}/sign-in`}
                            variant="contained"
                            sx={{
                              backgroundColor: buttonColor,
                              color: buttonFontColor,
                              borderRadius: '8px',
                              px: 4,
                              py: 1,
                              fontWeight: 'bold',
                              '&:hover': {
                                backgroundColor: buttonColor,
                                opacity: 0.9,
                              },
                            }}
                          >
                            Login
                          </Button>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>

                <Box
                  sx={{
                    maxWidth: '1000px',
                    width: '100%',
                    mt: 4,
                  }}
                >
                  <AiVideo
                    width="800px"
                    height="450px"
                    url={ThinkskillVideo}
                    secondaryColor={secondaryColor}
                    open={videoOpen}
                    setOpen={setVideoOpen}
                  />
                </Box>
              </Box>
            </Container>
          </Box>

        </Box>
      </AuthWrapper>
    </>
  );


};

export default LandingPage;
